<template>
  <h1 v-if="errorLoading">
    Oops, there was an issue loading this user, please close app or window and try again.
  </h1>
  <Loading v-else />
  <!-- Write user object to local cache then auto-launch vr immediately-->
</template>

<script setup lang="ts">
import { useBldgStore } from "../store/bldgStore";
import { useRoute } from "vue-router";
import { useUserStore } from "../store/userStore";
import { LoginPersonDTO } from "../store/generatedFetchClient";
import router from "../router";

const bldgStore = useBldgStore();

const route = useRoute();
const userStore = useUserStore();
var property = computed(() => bldgStore.property);
var user = computed(() => userStore.user);

let errorLoading = ref(false);

onMounted(() => {
  console.log("VR Training mounted");
  redirectWhenLoaded();
});

watch(property, redirectWhenLoaded);
watch(user, redirectWhenLoaded);

/// verify user is loaded (written to localStorage)
async function redirectWhenLoaded() {
  let siteCode = getParamAsString("sitecode");
  console.log("VR Training loaded for " + siteCode);

  let urlToken = getParamAsString("t");
  if (urlToken) {
    userStore.setAuthToken(urlToken);
  }

  let portalId: number = getParamAsNum("p");
  let userId = -1;

  // Optimistically pull user from localStorage and return immediately
  var cachedUserString = localStorage.getItem(siteCode! + "_user");
  var cachedUser = cachedUserString ? JSON.parse(cachedUserString) : null;
  if (cachedUser) {
    //&& !force) {
    console.log("Found cached user ", cachedUser);
    let cUser = cachedUser as LoginPersonDTO;
    userId = cUser.personId ?? 0;
  }

  //If user not found in local store already, pull user from server
  if (portalId > 0 && userId < 0) {
    try {
      await userStore.getUser(siteCode!, portalId, false);
      userId = userStore.user?.personId ?? 0;
    } catch (e: any) {
      console.warn("VRTraining> Error loading user", e);
    }
  }

  if (!userStore.isEmailVerifiedOrNotRequired) {
    router.push(`/${siteCode}/unconfirmedemail`);
  }

  // If user successfully loaded, then user object written to local storage.
  // VR code requires userObj.userId in local storage
  //   to make Accomplishments api callbacks work
  if (userId > 0) {
    location.assign(`/api/launch/starttour/${siteCode}/${userId}`);
    return;
  }

  //If we made it to here, something didn't load. Show error message
  errorLoading.value = true;
}

function getParamAsNum(paramName: string) {
  return Number.parseInt(route.query[paramName] as any);
}

function getParamAsString(paramName: string) {
  let paramValue = route.params[paramName] ?? route.query[paramName];
  if (paramValue) return typeof paramValue === "string" ? (paramValue as string) : paramValue[0];
  return "";
}
</script>
